import { useLayoutEffect, useRef } from 'react'

import { useGSAP } from '@/composables/useGSAP'

export type PaginationProps = {
  className?: string
  classNameItem?: string
  current: number
  max: number
  appear?: boolean
  delay?: number
}

const colors = ['bg-coral', 'bg-mid-blue', 'bg-light-blue']
const rotates = ['rotate-12', 'rotate-0', '-rotate-12', 'rotate-0']
export default function Pagination({
  className,
  classNameItem,
  current = 0,
  max = 3,
  appear = false,
  delay = 0,
}: PaginationProps) {
  const { gsap } = useGSAP()
  const ref = useRef<HTMLDivElement>(null)

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      if (appear) {
        gsap.timeline({ delay }).fromTo(
          ref.current,
          {
            opacity: 0,
            x: 20,
          },
          {
            opacity: 1,
            x: 0,
            duration: 0.5,
            ease: 'power2.out',
          }
        )
      }
    })

    return () => ctx.kill()
  }, [gsap, delay, appear, ref])

  return (
    <div ref={ref} aria-hidden='true' className={`Pagination ${className} flex`}>
      <div
        className={`text-left rounded-24 border-2 bg-tertiary border-secondary p-16 flex items-center justify-center ${classNameItem}`}
      >
        {Array.from({ length: max }, (_, i) => (
          <div
            key={i}
            className={`Pagination__Dot ${current === i ? 'Active' : ''} ${colors[i % colors.length]} ${rotates[i % rotates.length]}`}
          />
        ))}
      </div>
    </div>
  )
}
